let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bO5KC")).then(() => parcelRequire('9RwzH'));